import { imgUrl } from "../lib/api";

export const artAlt = (art) =>
  `${art?.title ? `${art.title} — ` : ""}Artwork by Kenny DePrince — ARTILLERY KDP`;

export { imgUrl };
